<template>
  <div>
    <section class="social">
      <div class="container social__container">
        <h2 class="social__title">Наши соцсети:</h2>
        <div class="social__content">
          <a href="https://instagram.com/amulet.irena?igshid=YmMyMTA2M2Y=" class="social__btn btn btn-reset inst" onclick="ym(56736205,'reachGoal','inst-love')">Инстаграм Отзывы</a>
          <a href="https://dzen.ru/a/Y35PS8MB_W4QXVeM" class="social__btn btn btn-reset site-amulets" onclick="ym(56736205,'reachGoal','testtosite')">Яндекс. Дзен</a>
        </div>
      </div>
    </section>
    <section class="amulets">
      <div class="container amulets__container">
        <h2 class="amulets__title">Отзывы о тесте</h2>
        <div class="review--item">
          <div class="review--title">Александра</div>
          <div class="review--text">У меня низкий уровень. Я так и предполагала. Нет у меня веры в себя, очень сложно что-то менять. Чувствую себя одинокой, хоть и состою в отношениях. Удивительно, какой точный тест. Буду работать над собой. Теперь ведь есть для этого инструменты. Огромное вам спасибо!</div>
        </div>
        <div class="review--item">
          <div class="review--title">Екатерина</div>
          <div class="review--text">Супер!! Невероятно точно!! Совпало каждое слово😍 Как же много зависит от уровня энергии. Я теперь лучше понимаю себя. Посмотрела на себя другими глазами. Буду следовать рекомендациям обязательно. Было очень-очень полезно. Спасибо😘🌺🌺🌺</div>
        </div>
        <div class="review--item">
          <div class="review--title">Мария</div>
          <div class="review--text">Вот откуда это постоянное чувство недостаточности. Я уже проговариваю аффирмации))) Очень хочется поменять уже все в жизни. А теперь я вижу, как много значит уровень энергии, как много от него зависит. Буду всем рекомендовать этот тест. У меня много знакомых, которым это точно необходимо!</div>
        </div>
        <div class="review--item">
          <div class="review--title">Кира</div>
          <div class="review--text">Благодарю сердечно за тест ❤️❤️❤️ Результатом не удивлена, так и чувствовала, прямо в точку! Теперь знаю, что делать дальше, чтобы изменить ситуацию. Мне очень помогли советы. Буду действовать! И всем рекомендую!</div>
        </div>
        <div class="review--item">
          <div class="review--title">Светлана</div>
          <div class="review--text">Очень точно! Огромное спасибо вам за этот тест. У меня не такая уж плохая ситуация, но все же очень хочется теперь стремиться к самому высокому уровню энергии. Особая благодарность за рекомендации! Уже выполняю!</div>
        </div>
        <div class="review--item">
          <div class="review--title">Татьяна</div>
          <div class="review--text">Тест очень удивил. Не ожидала такой точности. Результат полностью совпадает с моим ощущением себя. У меня средний уровень энергии любви. Так и есть. Я действительно, то красавица и богиня, то лучше бы никого не встретить сегодня😂</div>
        </div>
        <div class="more more-review">
          <a class="info__button btn_rs btn" :href="url" onclick="ym(56736205,'reachGoal','amuletslovetest')">Заказать амулет</a>
        </div>
      </div>
    </section><!-- Social -- BLOCK -->
  </div>
</template>

<script>
// Import Swiper styles
// import Swiper core and required modules
import { Navigation, Pagination, Lazy } from 'swiper';

// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from 'swiper/vue';

// Import Swiper styles
import 'swiper/swiper-bundle.css'
export default {
  name: "FooterResult",
  components: {
    Swiper,
    SwiperSlide
  },
  computed: {
    utm() {
      return this.$store.getters['utm']
    },
    url() {
      let link = 'https://store.taroirena.ru/shop/amulety/braslet-energiya-lyubvi/'
      if(this.utm.utm_source) {
        link += '?utm_source=' + this.utm.utm_source
      }
      if(this.utm.utm_medium) {
        link += '&utm_medium=' + this.utm.utm_medium
      }
      if(this.utm.utm_campaign) {
        link += '&utm_campaign=' + this.utm.utm_campaign
      }
      if(this.utm.utm_content) {
        link += '&utm_content=' + this.utm.utm_content
      }
      if(this.utm.utm_term) {
        link += '&utm_term=' + this.utm.utm_term
      }
      return link
    }
  },
  methods: {
    onVideoStart(item) {
      if(item.currentTarget.classList.contains('played')) {
        item.currentTarget.classList.remove('played')
        item.currentTarget.pause()
      }
      else {
        item.currentTarget.classList.add('played')
        item.currentTarget.play()
      }
    }
  },
  setup() {
    const onSwiper = (swiper) => {
      console.log(swiper);
    };
    const onSlideChange = () => {
      let current = document.querySelector('.swiper-slide-active')
      let video = current.querySelector('video')
      let lastVideo = document.querySelectorAll('video')
      for (let videoItem of lastVideo) {
        videoItem.classList.remove('played')
        videoItem.pause()
      }
      if(video){
        video.classList.add('played')
        video.play()
      }
    };
    return {
      onSwiper,
      onSlideChange,
      modules: [Navigation, Pagination, Lazy],
    };
  },
}
</script>
<style>
.swiper-slide {
  height: auto;
}
</style>